import request from './request'

export function fetchRechargeRecords (pageIndex = 1) {
  return request({
    method: 'post',
    url: '/access/v1/ls/rechargeWithdraw/records/1',
    data: { pageIndex }
  })
}
